import { render } from "./PersistenceNotification.vue?vue&type=template&id=01bc0953&scoped=true&ts=true"
import script from "./PersistenceNotification.vue?vue&type=script&lang=ts"
export * from "./PersistenceNotification.vue?vue&type=script&lang=ts"

import "./PersistenceNotification.vue?vue&type=style&index=0&id=01bc0953&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01bc0953"]])

export default __exports__